import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectCoverflow, Scrollbar } from 'swiper/modules';
import '../Pages/Main.css';
import 'swiper/css';
import 'swiper/css/scrollbar';
import 'swiper/css/effect-coverflow';
import './TestimonialCoverflow.css';

// Star Rating Component
const StarRating = ({ rating }) => {
  return (
    <div className="star-rating">
      {[...Array(5)].map((_, index) => (
        <span key={index} className={index < rating ? 'star filled' : 'star'}>
          ★
        </span>
      ))}
    </div>
  );
};

const TestimonialCoverflow = () => {
  const [testimonials, setTestimonials] = useState([]);
  const swiperRef = React.useRef(null);

  useEffect(() => {
    fetch("/testimonial.json")
      .then((response) => response.json())
      .then((data) => {
        const testimonialsWithRating = data.testimonials.map(testimonial => ({
          ...testimonial,
          rating: testimonial.rating || 5
        }));
        setTestimonials(testimonialsWithRating);
      })
      .catch((error) => console.error("Error fetching testimonials:", error));
  }, []);

  useEffect(() => {
    if (testimonials.length > 0 && swiperRef.current) {
      swiperRef.current.slideToLoop(0, 0);
    }
  }, [testimonials.length]);

  return (
    <section className="testimonial-coverflow-section product-showcase">
      <div className="container">
        <div className="row">
          <div className="col-12 text-center mb-4">
            <div className="section-heading">
              <h2 className="web">What Our Clients Say</h2>
              <p>Hear from healthcare professionals and organizations who trust our solutions to streamline their operations and deliver better patient care.</p>
            </div>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-12">
            <div className="testimonial-swiper-wrapper">
              <Swiper
                effect="coverflow"
                grabCursor={true}
                centeredSlides={true}
                slidesPerView="auto"
                initialSlide={0}
                onSwiper={(swiper) => { swiperRef.current = swiper; }}
                onInit={(swiper) => swiper.slideToLoop(0, 0)}
                coverflowEffect={{
                  rotate: 50,
                  stretch: 0,
                  depth: 100,
                  modifier: 1,
                  slideShadows: true,
                }}
                scrollbar={{ draggable: true, hide: false }}
                autoplay={{ delay: 3000, disableOnInteraction: false }}
                loop={testimonials.length > 3}
                modules={[EffectCoverflow, Autoplay, Scrollbar]}
                className="testimonial-swiper-coverflow"
              >
              {testimonials.map((testimonial) => (
                <SwiperSlide key={testimonial.id} className="testimonial-slide-coverflow">
                  <div className="testimonial-card">
                    <div className="testimonial-card-inner">
                      <div className="quote-icon">"</div>
                      <p className="testimonial-text">{testimonial.feedback}</p>
                      <StarRating rating={testimonial.rating || 5} />
                      <div className="testimonial-author">
                        <img 
                          src={testimonial.image.startsWith('/') ? testimonial.image : `/${testimonial.image}`} 
                          alt={testimonial.name} 
                          className="author-avatar"
                          onError={(e) => {
                            e.target.src = '/assets/img/client/1.jpg';
                          }}
                        />
                        <div className="author-info">
                          <h5>{testimonial.name}</h5>
                          <span>{testimonial.position}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialCoverflow;
